import { Typography } from '@euler/app/components/typography';
import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BiButton } from '@euler/app/flows/bi-dashboards/components/ui/BiButton';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDraftDetail } from '@euler/model/bi/draft';
import dayjs from 'dayjs';
import { X } from 'lucide-react-native';
import { memo } from 'react';
import { ScrollView, View } from 'react-native';
import { BiVisualizationBody } from '../bi-visualization/BiVisualizationBody';

/** A proposal full size, with why it was picked. */
export const ProposalFullPanel = memo(
  ({
    visible,
    draft,
    onClose,
  }: {
    visible: boolean;
    draft: BiDraftDetail;
    onClose: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const { current } = draft.result;
    return (
      <BottomPanel visible={visible} onClose={onClose} tall>
        <View style={{ flex: 1, padding: rpx(20), gap: rpx(12) }}>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              gap: rpx(8),
            }}
          >
            <View style={{ flex: 1, gap: rpx(4) }}>
              <Typography.Text
                medium
                size={rpx(16)}
                color={aiColors.foreground}
              >
                {draft.title}
              </Typography.Text>
              <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
                数据截至 {dayjs(current.asOf).format('M月D日 HH:mm')}
              </Typography.Text>
            </View>
            <BiButton
              icon={X}
              tone="quiet"
              accessibilityLabel="关闭"
              onPress={onClose}
            />
          </View>
          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{ gap: rpx(12), paddingBottom: rpx(16) }}
          >
            {draft.rationale ? (
              <Typography.Text
                size={rpx(13)}
                lineHeight={rpx(20)}
                color={aiColors.mutedForeground}
              >
                {draft.rationale}
              </Typography.Text>
            ) : null}
            <BiVisualizationBody viz={draft.viz} result={draft.result} />
            {current.truncated ? (
              <CardNotice text="符合条件的数据超过上限，这里只包含部分结果。" />
            ) : null}
          </ScrollView>
        </View>
      </BottomPanel>
    );
  },
);
